export default __webpack_public_path__ + "static/media/WriteAnimateShare.d9f92caf.gif";